import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as loginactions from '../../actions/login/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*locale*/
import String from '../../components/locales';
import Config from '../../actions/config';
import ObjGeneral from '../function';
import constants from '../function/constants';

/*Components*/
import LoginForm from '../../components/login/';
import LoginSSO from '../../components/loginSSO/';
import MessageWithIcon from '../../components/common/messageWithIcon';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: false,
      showErrorRedirect: false
    };
    this.showVersion = (props.showVersion === undefined) ? true : props.showVersion;
    // this variable determines the login mode on the website
    this.loginMode = (props.loginMode === undefined) ? Config.loginMode : props.loginMode;
  }

  componentDidMount() {
    if (this.props.match.params.lang) {
      String.setLanguage(this.props.match.params.lang);
      this.props.dashboardActions.handleLanguageChange(String);
    }

    // check if the user is previously authenticated
    const auth = localStoreFN().getItem('auth');
    this.setState({ isLogged: auth === 'true'});

    // check if it has a parameter in the url to redirect
    this.getParametersUrl();
  }

  handleLogin = async event => {
    event.preventDefault();

    await this.login({
      username: document.getElementById('user').value,
      password: document.getElementById('password').value
    });
  };

  handleLoginSSO = async (userLogin) => {
    await this.login(userLogin);
  };

  login = async (userLogin) => {
    const obj = {
      grant_type: 'password',
      username: userLogin.username,
      password: userLogin.password
    };

    await this.props.actions.saveLoginApi(obj);
  }

  /**
   * get encrypted parameter from url
   */
  getParametersUrl = () => {
    const href = window.location.href;
    const url = new URL(href);
    const params = url.searchParams;
    const argument = params.get('a');

    if (argument) {
      const decoder = ObjGeneral.decoderBase64(argument);

      if (decoder === null) {
        this.setState({ showErrorRedirect: true });
      } else {
        localStoreFN().setItem(constants.localStorage.redirectData, argument);
      }
    }
  };

  render() {
    const auth = this.props.auth || this.state.isLogged;

    // check if the user is authenticated and if redirection data is available
    if (ObjGeneral.shouldRedirectFromUrl(this.props.history, auth)) {
      return null;
    }

    if (this.state.showErrorRedirect) {
      return (
        <div className="redirect-container-message flex align-center justify-center">
          <MessageWithIcon
            title={this.props.language.login.main.redirectTitleError}
            message={this.props.language.login.main.redirectMessageError}
            icon="fas fa-exclamation-triangle"
          />
        </div>
      );
    }

    // if there is no redirection, continue with the process normally
    return (
      <div>
        {auth ? (
          <Redirect to="/dashboard" />
        ) : (
          <Fragment>
            {
              (this.loginMode.toLowerCase() === 'login-by-steps') ? (
                <LoginSSO
                  language={this.props.language}
                  message={this.props.message}
                  handleLogin={this.handleLoginSSO}
                  loading={this.props.loading}
                  showVersion={this.showVersion}
                />
              ) : (
                <LoginForm
                  language={this.props.language}
                  message={this.props.message}
                  handleLogin={this.handleLogin}
                  loading={this.props.loading}
                  showVersion={this.showVersion}
                />
              )
            }
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.reducer.login.auth,
  loading: state.reducer.login.loading,
  message: state.reducer.login.message,
  token: state.reducer.login.token,
  language: state.reducer.dashboard.language,
  loadingLanguage: state.reducer.dashboard.loadingLanguage
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(loginactions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

Login.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./source/client/containers/login/index.jsx